import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/metas-individuais')({
  component: lazyRouteComponent(
    () => import('@/features/metas/components/metas-individuais-page'),
    'MetasIndividuaisPage'
  ),
})
